import { api_url } from '../lib/api.js';
const API_URL = api_url();
export default API_URL;